webpackJsonp([18],{

/***/ 2729:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _should_verify_email = __webpack_require__(2730);

var _should_verify_email2 = _interopRequireDefault(_should_verify_email);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var siteName = config.SiteName;

    return {
        siteName: siteName
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_should_verify_email2.default);

/***/ }),

/***/ 2730:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _user_actions = __webpack_require__(781);

var _back_button = __webpack_require__(852);

var _back_button2 = _interopRequireDefault(_back_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShouldVerifyEmail = function (_React$Component) {
    (0, _inherits3.default)(ShouldVerifyEmail, _React$Component);

    function ShouldVerifyEmail(props) {
        (0, _classCallCheck3.default)(this, ShouldVerifyEmail);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ShouldVerifyEmail.__proto__ || (0, _getPrototypeOf2.default)(ShouldVerifyEmail)).call(this, props));

        _this.handleResend = function () {
            var email = new URLSearchParams(_this.props.location.search).get('email');

            _this.setState({ resendStatus: 'sending' });

            (0, _user_actions.resendVerification)(email, function () {
                _this.setState({ resendStatus: 'success' });
            }, function () {
                _this.setState({ resendStatus: 'failure' });
            });
        };

        _this.state = {
            resendStatus: 'none'
        };
        return _this;
    }

    (0, _createClass3.default)(ShouldVerifyEmail, [{
        key: 'render',
        value: function render() {
            var resendConfirm = '';
            if (this.state.resendStatus === 'success') {
                resendConfirm = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'p',
                        { className: 'alert alert-success' },
                        _react2.default.createElement('i', { className: 'fa fa-check' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'email_verify.sent',
                            defaultMessage: ' Verification email sent.'
                        })
                    )
                );
            }

            if (this.state.resendStatus === 'failure') {
                resendConfirm = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'p',
                        { className: 'alert alert-danger' },
                        _react2.default.createElement('i', { className: 'fa fa-times' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'email_verify.failed' })
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_back_button2.default, null),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    _react2.default.createElement(
                        'div',
                        { className: 'signup-team__container' },
                        _react2.default.createElement(
                            'h3',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'email_verify.almost',
                                defaultMessage: '{siteName}: You are almost done',
                                values: {
                                    siteName: this.props.siteName
                                }
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'p',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'email_verify.notVerifiedBody',
                                    defaultMessage: 'Please verify your email address. Check your inbox for an email.'
                                })
                            ),
                            _react2.default.createElement(
                                'button',
                                {
                                    onClick: this.handleResend,
                                    className: 'btn btn-primary'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'email_verify.resend',
                                    defaultMessage: 'Resend Email'
                                })
                            ),
                            resendConfirm
                        )
                    )
                )
            );
        }
    }]);
    return ShouldVerifyEmail;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = ShouldVerifyEmail;


ShouldVerifyEmail.propTypes = {
    location: _propTypes2.default.object.isRequired,
    siteName: _propTypes2.default.string
};

/***/ })

});


// WEBPACK FOOTER //
// 18.19b2fae5cf62cdefff98.js